import { useContext } from 'react'

import "./ViewAuditTrail.css"
import ActionCommonInfo from './ActionComponents/ActionCommonComponent/ActionCommonInfo'
import RevisionAction from './ActionComponents/RevisionAction/RevisionAction'
import { AuditTrailViewContext, AuditTrailViewContextProvider } from './AuditTrailViewContext'
import DataExport from './ActionComponents/DataExport/DataExport'
import EditFromPopupAction from './ActionComponents/EditFromPopupAction/EditFromPopupAction'
import NodeActions from './ActionComponents/NodeActions/NodeActions'
import MoveAction from './ActionComponents/MoveAction/MoveAction'
import RestoreBackupAction from './ActionComponents/RestoreBackupAction/RestoreBackupAction'
import ModuleAction from './ActionComponents/ModuleAction/ModuleAction'
import DisableUser from './ActionComponents/DisableUser/DisableUser'
import ConfirmView from './ActionComponents/ApplicationSetup/ConfirmView'
import CreatedMosRevision from './ActionComponents/RevisionAction/CreatedMosRevision'


const ViewAuditTrail = () =>{
  return  <AuditTrailViewContextProvider><ViewAuditTrailMain/></AuditTrailViewContextProvider>
}

/**
 * 
 * Note: this component is only able to return two blocks ActionCommonInfo and one matched condition
 */
const ViewAuditTrailMain = () =>{
  const {data} = useContext(AuditTrailViewContext)
  const {action_to_show,has_audit_trail_preview} = data.version_content || {}
  return (
    <div style={{ paddingBottom: "30px" }}>
      <ActionCommonInfo />


      {
        (()=>{
          if(has_audit_trail_preview){
            if (
              action_to_show?.includes("_MOVED") ||
              action_to_show?.includes("_NODE_DELETED") ||
              action_to_show?.includes("_COPIED")
            ) {
              return <MoveAction data={data} />;
            } else {
              return <NodeActions data={data} />;
            }
          }else if(
            action_to_show?.includes("CREATE_SECTION") || action_to_show?.includes("UPDATE_SECTION")
            || action_to_show?.includes("CREATE_STEP") || action_to_show?.includes("UPDATE_STEP") 
            || action_to_show?.includes("CREATE_SUBSTEP") || action_to_show?.includes("UPDATE_SUBSTEP")
            || action_to_show?.includes("CREATE_VIDEO") || action_to_show?.includes("UPDATE_VIDEO")
            || action_to_show?.includes("CREATE_CANVAS") || action_to_show?.includes("UPDATE_CANVAS")
            || action_to_show?.includes("CREATE_RICH_TEXT") || action_to_show?.includes("UPDATE_RICH_TEXT")
            || action_to_show?.includes("CREATE_ATTACHMENT") || action_to_show?.includes("UPDATE_ATTACHMENT")
          ){
            return <NodeActions data={data} />;
          }
          else if(action_to_show?.includes("_APPLICATION_SETUP")){
            return <ConfirmView data={data} />;
          }
          else if(action_to_show?.includes("UPDATE_")){
            return <EditFromPopupAction data={data} />
          }
          else if(action_to_show?.includes("CREATE_PROCEDURE_REVISION_MOS")){
            return <CreatedMosRevision data={data} />
          }
          else if((action_to_show?.includes("REVISION_") || action_to_show === "CREATE_PROCEDURE_REVISION")){
            if(action_to_show?.includes("REVISION_COPIED")){
              return <MoveAction data={data} />
            }else{
              return <RevisionAction data={data} />
            }
          }
          else if(action_to_show?.includes("EXPORT_")){
            return <DataExport data={data} />
          }
          else if(action_to_show === "Restored a Backup"){
            return <RestoreBackupAction />
          }
          else if(action_to_show?.includes("_MOVED") || action_to_show?.includes("_NODE_DELETED") || action_to_show?.includes("_COPIED")){
            return <MoveAction data={data} />
          }
          else if(action_to_show?.includes("Updated module") || action_to_show?.includes("Created module")){
            return <ModuleAction data={data} />;
          }else if(action_to_show?.includes("DISABLED_USER") || action_to_show?.includes("ENABLED_USER")){
            return <DisableUser data={data} />;
          }
          
        })()}
      </div>
    );
  };

export default ViewAuditTrail;